export default "__VITE_ASSET__xhsU$Wf3__"